import { initials } from '../lib/format.js';

const SIZE = { sm: 'h-6 w-6 text-[0.625rem]', md: 'h-8 w-8 text-xs' } as const;

/**
 * Avatar als Initialen. Die Farbe kommt aus einem Token (`--color-avatar-*`),
 * nicht aus einem Hex-Wert im Markup (Akzeptanz A11).
 */
export function Avatar({
  name,
  color,
  size = 'sm',
}: {
  name: string;
  color: string;
  size?: keyof typeof SIZE;
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-[var(--color-avatar-text)] ${SIZE[size]}`}
      style={{ backgroundColor: `var(--color-avatar-${color}, var(--color-avatar-slate))` }}
      title={name}
      aria-label={name}
    >
      {initials(name)}
    </span>
  );
}
